<template>
  <v-container v-show="showErrorMessage">
    <v-layout>
      <v-flex>
        <v-snackbar
          v-model="showErrorMessage"
          color="error"
          multi-line
          top
          :timeout="-1"
        >
          <ul>
            <li v-for="(item, index) in error" :key="index">
              <span v-html="item" />
            </li>
          </ul>
          <template #action="{ attrs }">
            <v-btn text @click="showErrorMessage = false" v-bind="attrs">
              {{ $t("common.CLOSE") }}
            </v-btn>
          </template>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as types from "@/store/mutation-types";
import { formatErrorMessages } from "@/utils/utils.js";

export default {
  name: "ErrorMessage",
  computed: {
    showErrorMessage: {
      get() {
        return this.$store.state.error.showErrorMessage;
      },
      set(value) {
        this.$store.commit(types.SHOW_ERROR, value);
      },
    },
    error() {
      return formatErrorMessages(
        "errors",
        this.$store.state.error.errorMessage
      );
    },
  },
  watch: {
    error() {
      setTimeout(() => {
        this.showErrorMessage = this.error !== null;
      }, 100);
    },
  },
};
</script>
